import { useTranslation } from 'react-i18next';
import { signUpEnabled } from '../../context/GlobalContext';

const SignUpClosedNotice = () => {
  const { t } = useTranslation();

  if (signUpEnabled) return null;

  return <div className="no-new-teams">⚠️ {t('auth.signUpClosed')}</div>;
};

export default SignUpClosedNotice;
